import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  ESpecialCategorySortField,
  ISpecialCategory,
  PSpecialCategoryFilter,
} from "src/core/specialCategory/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface ISpecialCategoryState {
  specialCategorys: ISpecialCategory[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: ISpecialCategoryState = {
  specialCategorys: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "special-category/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "special-category/FETCH_SUCCEEDED";
const FETCH_FAILED = "special-category/FETCH_FAILED";
const POLLING_START_REQUESTED = "special-category/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "special-category/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: ISpecialCategory[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PSpecialCategoryFilter;
    pagination: IPagination;
    sorts: ISort<ESpecialCategorySortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<ISpecialCategoryState, TActions> = (
  state = initialState,
  action
) => {
  return produce<ISpecialCategoryState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.specialCategorys = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
